import { render } from "./SendingPrompt.vue?vue&type=template&id=66750655&scoped=true"
import script from "./SendingPrompt.vue?vue&type=script&lang=js"
export * from "./SendingPrompt.vue?vue&type=script&lang=js"

import "./SendingPrompt.vue?vue&type=style&index=0&id=66750655&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66750655"]])

export default __exports__